// modules
import React from 'react';
import { observer } from 'mobx-react';
import LocaleService from 'modules/Localization';
// store
import { useStore } from 'modules/Stores';
// components
import {
  Text,
  View,
  HighLowValue,
  LoadingBlock,
} from '@upstox/upstox-ui';
// constants
import { MARKET_FEEDER_MODES } from 'modules/LiveData/constants';
// utils
import { getLtpAndLtpChange, getSpotLiveDataLtp } from 'modules/OptionChain/utils';
// hooks
import { useSubscribeScripAndGetValue } from 'utils/hooks';
// styles
import * as css from '../../styles';

const SpotPriceCell: React.FC = () => {
  const {
    loading,
    spotScripData,
    isOptionChainAvailable,
  } = useStore('OptionChainStore');

  const spotLiveData = useSubscribeScripAndGetValue(
    spotScripData?.instrumentKey || '',
    MARKET_FEEDER_MODES.LTPC,
    true,
  );

  const spotLiveDataLtp = getSpotLiveDataLtp(
    spotLiveData?.lastTradedPrice,
    spotLiveData?.close,
  );

  const spotLiveDataClose = spotLiveData?.close || '';

  const {
    ltpChange: spotLtpChange,
    value: readableSpotLtpChange,
    formattedLtp: formattedSpotLtp,
  } = getLtpAndLtpChange(
    spotLiveDataLtp,
    spotLiveDataClose,
    true,
    spotScripData?.exchangeToken || '',
  );

  return (
    <View>
      <Text css={css.spotLabel} family="tvFont">
        {LocaleService.translate('SPOT_PRICE')}
      </Text>
      {(isOptionChainAvailable && loading) ? (
        <LoadingBlock height={20} width={80} />
      ) : (
        <View flex flexDirection="column">
          <Text css={css.lastTraded} family="tvFont">
            {formattedSpotLtp}
          </Text>
          <HighLowValue ltpChange={spotLtpChange} size="s" family="tvFont">
            {readableSpotLtpChange}
          </HighLowValue>
        </View>
      )}
    </View>
  );
};

export default observer(SpotPriceCell);
